import { Component, Injector, OnInit } from '@angular/core';
import { Promo } from 'src/app/models/promo';
import { PromoService } from 'src/app/services/promo.service';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-list-promo',
  templateUrl: './list-promo.component.html',
  styleUrls: ['./list-promo.component.css']
})
export class ListPromoComponent implements OnInit {
  public promos: Promo[] = [];
  public isLoadingPromo = true;
  public isEmptyPromo = false;

  constructor(
    private promoService: PromoService,
    private router: Router
  ) { }

  ngOnInit() {
    firebase.analytics().logEvent('informasi_lihat_informasi_button');
    firebase.analytics().logEvent('informasi_page');

    this.promos = this.promoService.getPromo(
      (data) => {
        this.promos = data;
        this.isEmptyPromo = false;
        this.isLoadingPromo = false;

        if (this.promos.length === 0) {
          this.isEmptyPromo = true;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  public navigateToPromoDetail(promo: Promo): void {
    localStorage.setItem(promo.id, JSON.stringify(promo));
    this.router.navigate(['/detail-promo/' + promo.id]);
  }
}
